import { Attachment } from 'src/app/models/server/attachment';

export class DialogSelectFolderFilesData {
    public constructor(public attachments: Attachment[]) {}
}
